import { Injectable } from '@angular/core';
import { JsonSerializable } from '../models/models';
import { DateTime } from 'luxon';

export interface UrlMatrixParam {
    propertyName: string;
    propertyType: string;
    propertyValue: any;
}

@Injectable()
export class HttpJsonUtilities {
    public concatenateToMatrixUrlParams(params: UrlMatrixParam[]): string {
        let formatedString = '';
        params.forEach(element => {
            // eslint-disable-next-line eqeqeq
            if (element.propertyValue != undefined) {
                formatedString += element.propertyName + ':' + this.toJson(element.propertyType, element.propertyValue) + ';';
            }
        });

        return formatedString;
    }

    public toMatrixUrlParams(object: any): string {
        let formatedString = '';
        for (const property in object) {
            if (object.hasOwnProperty(property)) {
                const value = object[property];
                // eslint-disable-next-line eqeqeq
                if (value != undefined) {
                    const valueString: string = this.toJson(undefined, value);
                    formatedString += property + ':' + valueString + ';';
                }
            }
        }
        return formatedString;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public fromJson(typeName: string, value: any): any {
      // eslint-disable-next-line eqeqeq
        if (value != undefined && typeName === 'luxon.DateTime') {
            return DateTime.fromISO(value);
        }

        return value;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public toJson(typeName: string, value: any): string {
        if (typeName === 'string' && (!value || value.trim() === '')) {
            return undefined;
        }

        // eslint-disable-next-line eqeqeq
        if (value != undefined) {
            if (value instanceof JsonSerializable) {
                return value.toJson();
            }
            if (typeName === 'luxon.DateTime') {
                return value.toString();
            }
            return value + '';
        }

        return '';
    }
}
